import subVisual from "@/assets/images/user/subVisual.png";
import subVisualTxt from "@/assets/images/user/subVisualTxt.svg";

export default function SubVisual() {
    return (
        <div className="relative h-[240px] md:h-[480px]">
            <img src={subVisual} alt="배경이미지" className="w-full h-full object-cover" />
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 translate-y-[calc(-50%+40px)] h-[48px] md:h-auto">
                <img src={subVisualTxt} alt="GXG2025" className="max-h-full" />
            </div>
        </div>
    );
}
